import React from "react";

import { Title as Header } from "Cobalt/Header";
import PartnerContext from "Common/PartnerContext";
import PartnerProvider from "Common/PartnerProvider";

import Chrome from "./Chrome";

const FourOhFour = () => (
  <Chrome>
    <PartnerProvider>
      <PartnerContext.Consumer>
        {() => (
          <>
            <Header>Invalid Link</Header>
            <p>
              Hmm, the page you&apos;re looking for can&apos;t be found. Return to our <a href="/">front page</a> or contact us at{" "}
              <a href="https://get.simplyinsured.com/contact">get.simplyinsured.com/contact</a> if you can&apos;t find what you&apos;re looking for.
            </p>
          </>
        )}
      </PartnerContext.Consumer>
    </PartnerProvider>
  </Chrome>
);

export default FourOhFour;
